import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconKeyboardTabLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.75 17.75a.725.725 0 0 1-.535-.216A.726.726 0 0 1 20 17V7c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216c.213 0 .391.072.535.216A.725.725 0 0 1 21.5 7v10c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216Zm-5.806-5H3.25a.725.725 0 0 1-.534-.216A.726.726 0 0 1 2.5 12c0-.213.072-.391.216-.534a.725.725 0 0 1 .534-.216h11.685l-3.299-3.333a.704.704 0 0 1-.21-.51.713.713 0 0 1 .22-.526.702.702 0 0 1 .52-.206c.211 0 .386.07.524.208l4.485 4.484a.829.829 0 0 1 .256.634.832.832 0 0 1-.256.632l-4.494 4.494a.693.693 0 0 1-.513.207.753.753 0 0 1-.531-.207.7.7 0 0 1-.228-.535.746.746 0 0 1 .227-.534l3.308-3.308Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconKeyboardTabLine;
